// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvestmentThresholdPropertyDto
 */
export interface IInvestmentThresholdPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IInvestmentThresholdPropertyDto
     */
    investment_threshold?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentThresholdPropertyDto
     */
    investment_threshold_state?: IInvestmentThresholdPropertyDtoInvestmentThresholdStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IInvestmentThresholdPropertyDtoInvestmentThresholdStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IInvestmentThresholdPropertyDto interface.
 */
export function instanceOfIInvestmentThresholdPropertyDto(value: object): value is IInvestmentThresholdPropertyDto {
    return true;
}

export function IInvestmentThresholdPropertyDtoFromJSON(json: any): IInvestmentThresholdPropertyDto {
    return IInvestmentThresholdPropertyDtoFromJSONTyped(json, false);
}

export function IInvestmentThresholdPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentThresholdPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'investment_threshold': json['investment_threshold'] == null ? undefined : json['investment_threshold'],
        'investment_threshold_state': json['investment_threshold_state'] == null ? undefined : json['investment_threshold_state'],
    };
}

export function IInvestmentThresholdPropertyDtoToJSON(json: any): IInvestmentThresholdPropertyDto {
    return IInvestmentThresholdPropertyDtoToJSONTyped(json, false);
}

export function IInvestmentThresholdPropertyDtoToJSONTyped(value?: IInvestmentThresholdPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investment_threshold': value['investment_threshold'],
        'investment_threshold_state': value['investment_threshold_state'],
    };
}

